//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class LocationApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getLocationById(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/locations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLocationById(_response);
        });
    }

    protected processGetLocationById(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getFacilities(locationId: number | null | undefined): Promise<SearchableFacilityStructure[]> {
        let url_ = this.baseUrl + "/api/v1/locations/facilities?";
        if (locationId !== undefined && locationId !== null)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFacilities(_response);
        });
    }

    protected processGetFacilities(response: Response): Promise<SearchableFacilityStructure[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableFacilityStructure[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableFacilityStructure[]>(null as any);
    }

    getLocationsByDepartment(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/locations/department/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLocationsByDepartment(_response);
        });
    }

    protected processGetLocationsByDepartment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getLocationsBySubdepartment(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/locations/subdepartment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLocationsBySubdepartment(_response);
        });
    }

    protected processGetLocationsBySubdepartment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getLocationsByCentrum(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/locations/centrum/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLocationsByCentrum(_response);
        });
    }

    protected processGetLocationsByCentrum(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getLocationsBySubcentrum(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/locations/subcentrum/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLocationsBySubcentrum(_response);
        });
    }

    protected processGetLocationsBySubcentrum(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getId(name: string): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/locations/getId/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetId(_response);
        });
    }

    protected processGetId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class PagesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    pageTree(id: number): Promise<SearchableSpaarnePage[]> {
        let url_ = this.baseUrl + "/api/v1/pages/children/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPageTree(_response);
        });
    }

    protected processPageTree(response: Response): Promise<SearchableSpaarnePage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableSpaarnePage[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableSpaarnePage[]>(null as any);
    }

    centrumPageTree(id: number): Promise<LinkData[]> {
        let url_ = this.baseUrl + "/api/v1/pages/centrum-children/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCentrumPageTree(_response);
        });
    }

    protected processCentrumPageTree(response: Response): Promise<LinkData[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LinkData[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LinkData[]>(null as any);
    }

    getHomepage(languageCode: string): Promise<SearchableHomePage> {
        let url_ = this.baseUrl + "/api/v1/pages/homepage/{languageCode}";
        if (languageCode === undefined || languageCode === null)
            throw new Error("The parameter 'languageCode' must be defined.");
        url_ = url_.replace("{languageCode}", encodeURIComponent("" + languageCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHomepage(_response);
        });
    }

    protected processGetHomepage(response: Response): Promise<SearchableHomePage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableHomePage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableHomePage>(null as any);
    }

    getSpaarnePage(languageCode: string | null | undefined, grandParentSlug: string | null | undefined, parentSlug: string | null | undefined, slug: string | null | undefined): Promise<SearchableSpaarnePage> {
        let url_ = this.baseUrl + "/api/v1/pages/spaarne?";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        if (grandParentSlug !== undefined && grandParentSlug !== null)
            url_ += "grandParentSlug=" + encodeURIComponent("" + grandParentSlug) + "&";
        if (parentSlug !== undefined && parentSlug !== null)
            url_ += "parentSlug=" + encodeURIComponent("" + parentSlug) + "&";
        if (slug !== undefined && slug !== null)
            url_ += "slug=" + encodeURIComponent("" + slug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSpaarnePage(_response);
        });
    }

    protected processGetSpaarnePage(response: Response): Promise<SearchableSpaarnePage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableSpaarnePage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableSpaarnePage>(null as any);
    }

    getLocationOrSpaarnePageBySlug(slug: string): Promise<SearchableBasePage> {
        let url_ = this.baseUrl + "/api/v1/pages/locationOrSpaarne/{slug}";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLocationOrSpaarnePageBySlug(_response);
        });
    }

    protected processGetLocationOrSpaarnePageBySlug(response: Response): Promise<SearchableBasePage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableBasePage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableBasePage>(null as any);
    }

    getLocationPageBySlug(slug: string): Promise<SearchableLocationPage> {
        let url_ = this.baseUrl + "/api/v1/pages/locations/{slug}";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLocationPageBySlug(_response);
        });
    }

    protected processGetLocationPageBySlug(response: Response): Promise<SearchableLocationPage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableLocationPage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableLocationPage>(null as any);
    }

    getLocationPages(): Promise<SearchableLocationPage[]> {
        let url_ = this.baseUrl + "/api/v1/pages/locations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLocationPages(_response);
        });
    }

    protected processGetLocationPages(response: Response): Promise<SearchableLocationPage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableLocationPage[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableLocationPage[]>(null as any);
    }

    getCentraPageBySlug(slug: string): Promise<SearchableCentrumPage> {
        let url_ = this.baseUrl + "/api/v1/pages/centra/{slug}";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCentraPageBySlug(_response);
        });
    }

    protected processGetCentraPageBySlug(response: Response): Promise<SearchableCentrumPage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableCentrumPage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableCentrumPage>(null as any);
    }

    getCentraPages(): Promise<SearchableCentrumPage[]> {
        let url_ = this.baseUrl + "/api/v1/pages/centra";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCentraPages(_response);
        });
    }

    protected processGetCentraPages(response: Response): Promise<SearchableCentrumPage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableCentrumPage[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableCentrumPage[]>(null as any);
    }

    getSubcentraPageBySlug(slug: string): Promise<SearchableSubcentraPage> {
        let url_ = this.baseUrl + "/api/v1/pages/subcentra/{slug}";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubcentraPageBySlug(_response);
        });
    }

    protected processGetSubcentraPageBySlug(response: Response): Promise<SearchableSubcentraPage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableSubcentraPage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableSubcentraPage>(null as any);
    }

    getSubcentraPages(): Promise<SearchableSubcentraPage[]> {
        let url_ = this.baseUrl + "/api/v1/pages/subcentra";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubcentraPages(_response);
        });
    }

    protected processGetSubcentraPages(response: Response): Promise<SearchableSubcentraPage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableSubcentraPage[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableSubcentraPage[]>(null as any);
    }

    getDepartmentPageBySlug(slug: string): Promise<SearchableDepartmentPage> {
        let url_ = this.baseUrl + "/api/v1/pages/departments/{slug}";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDepartmentPageBySlug(_response);
        });
    }

    protected processGetDepartmentPageBySlug(response: Response): Promise<SearchableDepartmentPage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableDepartmentPage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableDepartmentPage>(null as any);
    }

    getDepartmentPages(): Promise<SearchableDepartmentPage[]> {
        let url_ = this.baseUrl + "/api/v1/pages/departments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDepartmentPages(_response);
        });
    }

    protected processGetDepartmentPages(response: Response): Promise<SearchableDepartmentPage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableDepartmentPage[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableDepartmentPage[]>(null as any);
    }

    getSubdepartmentPageBySlug(slug: string): Promise<SearchableSubdepartmentPage> {
        let url_ = this.baseUrl + "/api/v1/pages/subdepartments/{slug}";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubdepartmentPageBySlug(_response);
        });
    }

    protected processGetSubdepartmentPageBySlug(response: Response): Promise<SearchableSubdepartmentPage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableSubdepartmentPage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableSubdepartmentPage>(null as any);
    }

    getSubdepartmentPages(): Promise<SearchableSubdepartmentPage[]> {
        let url_ = this.baseUrl + "/api/v1/pages/subdepartments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubdepartmentPages(_response);
        });
    }

    protected processGetSubdepartmentPages(response: Response): Promise<SearchableSubdepartmentPage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableSubdepartmentPage[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableSubdepartmentPage[]>(null as any);
    }

    getSpecialistPageBySlug(slug: string): Promise<SearchableSpecialistPage> {
        let url_ = this.baseUrl + "/api/v1/pages/specialists/{slug}";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSpecialistPageBySlug(_response);
        });
    }

    protected processGetSpecialistPageBySlug(response: Response): Promise<SearchableSpecialistPage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableSpecialistPage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableSpecialistPage>(null as any);
    }

    getSpecialistPages(): Promise<SearchableSpecialistPage[]> {
        let url_ = this.baseUrl + "/api/v1/pages/specialists";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSpecialistPages(_response);
        });
    }

    protected processGetSpecialistPages(response: Response): Promise<SearchableSpecialistPage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableSpecialistPage[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableSpecialistPage[]>(null as any);
    }

    getRandomSpecialists(department: string | null | undefined, subdepartment: string | null | undefined, centrum: string | null | undefined, subcentra: string | null | undefined, count: number | undefined): Promise<SearchableSpecialistPage[]> {
        let url_ = this.baseUrl + "/api/v1/pages/specialists/random?";
        if (department !== undefined && department !== null)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        if (subdepartment !== undefined && subdepartment !== null)
            url_ += "subdepartment=" + encodeURIComponent("" + subdepartment) + "&";
        if (centrum !== undefined && centrum !== null)
            url_ += "centrum=" + encodeURIComponent("" + centrum) + "&";
        if (subcentra !== undefined && subcentra !== null)
            url_ += "subcentra=" + encodeURIComponent("" + subcentra) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRandomSpecialists(_response);
        });
    }

    protected processGetRandomSpecialists(response: Response): Promise<SearchableSpecialistPage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableSpecialistPage[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableSpecialistPage[]>(null as any);
    }

    getCrisisBanner(): Promise<SearchableCrisisBannerPage> {
        let url_ = this.baseUrl + "/api/v1/pages/crisis-banner";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCrisisBanner(_response);
        });
    }

    protected processGetCrisisBanner(response: Response): Promise<SearchableCrisisBannerPage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableCrisisBannerPage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableCrisisBannerPage>(null as any);
    }

    getResearchPageBySlug(slug: string): Promise<SearchableResearchPage> {
        let url_ = this.baseUrl + "/api/v1/pages/research/{slug}";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetResearchPageBySlug(_response);
        });
    }

    protected processGetResearchPageBySlug(response: Response): Promise<SearchableResearchPage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableResearchPage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableResearchPage>(null as any);
    }

    getNewsPage(slug: string): Promise<SearchableNewsPage> {
        let url_ = this.baseUrl + "/api/v1/pages/news/{slug}";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNewsPage(_response);
        });
    }

    protected processGetNewsPage(response: Response): Promise<SearchableNewsPage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableNewsPage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableNewsPage>(null as any);
    }

    getNewsPages(): Promise<SearchableNewsPage[]> {
        let url_ = this.baseUrl + "/api/v1/pages/news";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNewsPages(_response);
        });
    }

    protected processGetNewsPages(response: Response): Promise<SearchableNewsPage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableNewsPage[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableNewsPage[]>(null as any);
    }

    getNewsPagesBySlugs(slugs: string[] | null | undefined): Promise<SearchableNewsPage[]> {
        let url_ = this.baseUrl + "/api/v1/pages/news/slugs?";
        if (slugs !== undefined && slugs !== null)
            slugs && slugs.forEach(item => { url_ += "slugs=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNewsPagesBySlugs(_response);
        });
    }

    protected processGetNewsPagesBySlugs(response: Response): Promise<SearchableNewsPage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableNewsPage[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableNewsPage[]>(null as any);
    }

    getNewsTeasers(refs: string[] | null | undefined): Promise<NewsTeaserResult[]> {
        let url_ = this.baseUrl + "/api/v1/pages/news/teasers?";
        if (refs !== undefined && refs !== null)
            refs && refs.forEach(item => { url_ += "refs=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNewsTeasers(_response);
        });
    }

    protected processGetNewsTeasers(response: Response): Promise<NewsTeaserResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewsTeaserResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewsTeaserResult[]>(null as any);
    }

    getNewsPagesByIds(ids: number[] | null | undefined): Promise<SearchableNewsPage[]> {
        let url_ = this.baseUrl + "/api/v1/pages/news/ids?";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNewsPagesByIds(_response);
        });
    }

    protected processGetNewsPagesByIds(response: Response): Promise<SearchableNewsPage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableNewsPage[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableNewsPage[]>(null as any);
    }

    getFilteredNews(department: string | null | undefined, subdepartment: string | null | undefined, specialist: string | null | undefined, tags: string[] | null | undefined, centrum: string | null | undefined, subcentra: string | null | undefined, dossier: string | null | undefined, page: number | undefined, pageSize: number | undefined, shouldContainExcludedTags: boolean | undefined, excludeHighlighted: boolean | undefined): Promise<SearchableNewsPage[]> {
        let url_ = this.baseUrl + "/api/v1/pages/news/filter?";
        if (department !== undefined && department !== null)
            url_ += "Department=" + encodeURIComponent("" + department) + "&";
        if (subdepartment !== undefined && subdepartment !== null)
            url_ += "Subdepartment=" + encodeURIComponent("" + subdepartment) + "&";
        if (specialist !== undefined && specialist !== null)
            url_ += "Specialist=" + encodeURIComponent("" + specialist) + "&";
        if (tags !== undefined && tags !== null)
            tags && tags.forEach(item => { url_ += "Tags=" + encodeURIComponent("" + item) + "&"; });
        if (centrum !== undefined && centrum !== null)
            url_ += "Centrum=" + encodeURIComponent("" + centrum) + "&";
        if (subcentra !== undefined && subcentra !== null)
            url_ += "Subcentra=" + encodeURIComponent("" + subcentra) + "&";
        if (dossier !== undefined && dossier !== null)
            url_ += "Dossier=" + encodeURIComponent("" + dossier) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (shouldContainExcludedTags === null)
            throw new Error("The parameter 'shouldContainExcludedTags' cannot be null.");
        else if (shouldContainExcludedTags !== undefined)
            url_ += "ShouldContainExcludedTags=" + encodeURIComponent("" + shouldContainExcludedTags) + "&";
        if (excludeHighlighted === null)
            throw new Error("The parameter 'excludeHighlighted' cannot be null.");
        else if (excludeHighlighted !== undefined)
            url_ += "ExcludeHighlighted=" + encodeURIComponent("" + excludeHighlighted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredNews(_response);
        });
    }

    protected processGetFilteredNews(response: Response): Promise<SearchableNewsPage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableNewsPage[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableNewsPage[]>(null as any);
    }

    getDossierNews(department: string | null | undefined, subdepartment: string | null | undefined, specialist: string | null | undefined, tags: string[] | null | undefined, centrum: string | null | undefined, subcentra: string | null | undefined, dossier: string | null | undefined, page: number | undefined, pageSize: number | undefined, shouldContainExcludedTags: boolean | undefined, excludeHighlighted: boolean | undefined): Promise<DossierNewsResult> {
        let url_ = this.baseUrl + "/api/v1/pages/news/dossier?";
        if (department !== undefined && department !== null)
            url_ += "Department=" + encodeURIComponent("" + department) + "&";
        if (subdepartment !== undefined && subdepartment !== null)
            url_ += "Subdepartment=" + encodeURIComponent("" + subdepartment) + "&";
        if (specialist !== undefined && specialist !== null)
            url_ += "Specialist=" + encodeURIComponent("" + specialist) + "&";
        if (tags !== undefined && tags !== null)
            tags && tags.forEach(item => { url_ += "Tags=" + encodeURIComponent("" + item) + "&"; });
        if (centrum !== undefined && centrum !== null)
            url_ += "Centrum=" + encodeURIComponent("" + centrum) + "&";
        if (subcentra !== undefined && subcentra !== null)
            url_ += "Subcentra=" + encodeURIComponent("" + subcentra) + "&";
        if (dossier !== undefined && dossier !== null)
            url_ += "Dossier=" + encodeURIComponent("" + dossier) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (shouldContainExcludedTags === null)
            throw new Error("The parameter 'shouldContainExcludedTags' cannot be null.");
        else if (shouldContainExcludedTags !== undefined)
            url_ += "ShouldContainExcludedTags=" + encodeURIComponent("" + shouldContainExcludedTags) + "&";
        if (excludeHighlighted === null)
            throw new Error("The parameter 'excludeHighlighted' cannot be null.");
        else if (excludeHighlighted !== undefined)
            url_ += "ExcludeHighlighted=" + encodeURIComponent("" + excludeHighlighted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDossierNews(_response);
        });
    }

    protected processGetDossierNews(response: Response): Promise<DossierNewsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DossierNewsResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DossierNewsResult>(null as any);
    }

    getDossierHighlight(dossierPageId: number | null | undefined, dossierTitle: string | null | undefined, pageSize: number | undefined): Promise<DossierHighlightResult> {
        let url_ = this.baseUrl + "/api/v1/pages/news/dossier-highlight?";
        if (dossierPageId !== undefined && dossierPageId !== null)
            url_ += "dossierPageId=" + encodeURIComponent("" + dossierPageId) + "&";
        if (dossierTitle !== undefined && dossierTitle !== null)
            url_ += "dossierTitle=" + encodeURIComponent("" + dossierTitle) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDossierHighlight(_response);
        });
    }

    protected processGetDossierHighlight(response: Response): Promise<DossierHighlightResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DossierHighlightResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DossierHighlightResult>(null as any);
    }

    getFilteredNewsCount(department: string | null | undefined, subdepartment: string | null | undefined, specialist: string | null | undefined, tags: string[] | null | undefined, centrum: string | null | undefined, subcentra: string | null | undefined, dossier: string | null | undefined, page: number | undefined, pageSize: number | undefined, shouldContainExcludedTags: boolean | undefined, excludeHighlighted: boolean | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/pages/news/count/filter?";
        if (department !== undefined && department !== null)
            url_ += "Department=" + encodeURIComponent("" + department) + "&";
        if (subdepartment !== undefined && subdepartment !== null)
            url_ += "Subdepartment=" + encodeURIComponent("" + subdepartment) + "&";
        if (specialist !== undefined && specialist !== null)
            url_ += "Specialist=" + encodeURIComponent("" + specialist) + "&";
        if (tags !== undefined && tags !== null)
            tags && tags.forEach(item => { url_ += "Tags=" + encodeURIComponent("" + item) + "&"; });
        if (centrum !== undefined && centrum !== null)
            url_ += "Centrum=" + encodeURIComponent("" + centrum) + "&";
        if (subcentra !== undefined && subcentra !== null)
            url_ += "Subcentra=" + encodeURIComponent("" + subcentra) + "&";
        if (dossier !== undefined && dossier !== null)
            url_ += "Dossier=" + encodeURIComponent("" + dossier) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (shouldContainExcludedTags === null)
            throw new Error("The parameter 'shouldContainExcludedTags' cannot be null.");
        else if (shouldContainExcludedTags !== undefined)
            url_ += "ShouldContainExcludedTags=" + encodeURIComponent("" + shouldContainExcludedTags) + "&";
        if (excludeHighlighted === null)
            throw new Error("The parameter 'excludeHighlighted' cannot be null.");
        else if (excludeHighlighted !== undefined)
            url_ += "ExcludeHighlighted=" + encodeURIComponent("" + excludeHighlighted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredNewsCount(_response);
        });
    }

    protected processGetFilteredNewsCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getEventBySlug(slug: string): Promise<SearchableAgendaEventPage> {
        let url_ = this.baseUrl + "/api/v1/pages/events/{slug}";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEventBySlug(_response);
        });
    }

    protected processGetEventBySlug(response: Response): Promise<SearchableAgendaEventPage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableAgendaEventPage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableAgendaEventPage>(null as any);
    }

    getEventPages(): Promise<SearchableAgendaEventPage[]> {
        let url_ = this.baseUrl + "/api/v1/pages/events";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEventPages(_response);
        });
    }

    protected processGetEventPages(response: Response): Promise<SearchableAgendaEventPage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableAgendaEventPage[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableAgendaEventPage[]>(null as any);
    }

    getFilteredEvents(department: string | null | undefined, subdepartment: string | null | undefined, specialist: string | null | undefined, tags: string[] | null | undefined, centrum: string | null | undefined, subcentra: string | null | undefined, dossier: string | null | undefined, page: number | undefined, pageSize: number | undefined): Promise<SearchableAgendaEventPage[]> {
        let url_ = this.baseUrl + "/api/v1/pages/events/filter?";
        if (department !== undefined && department !== null)
            url_ += "Department=" + encodeURIComponent("" + department) + "&";
        if (subdepartment !== undefined && subdepartment !== null)
            url_ += "Subdepartment=" + encodeURIComponent("" + subdepartment) + "&";
        if (specialist !== undefined && specialist !== null)
            url_ += "Specialist=" + encodeURIComponent("" + specialist) + "&";
        if (tags !== undefined && tags !== null)
            tags && tags.forEach(item => { url_ += "Tags=" + encodeURIComponent("" + item) + "&"; });
        if (centrum !== undefined && centrum !== null)
            url_ += "Centrum=" + encodeURIComponent("" + centrum) + "&";
        if (subcentra !== undefined && subcentra !== null)
            url_ += "Subcentra=" + encodeURIComponent("" + subcentra) + "&";
        if (dossier !== undefined && dossier !== null)
            url_ += "Dossier=" + encodeURIComponent("" + dossier) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredEvents(_response);
        });
    }

    protected processGetFilteredEvents(response: Response): Promise<SearchableAgendaEventPage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableAgendaEventPage[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableAgendaEventPage[]>(null as any);
    }

    getFilteredEventsCount(department: string | null | undefined, subdepartment: string | null | undefined, specialist: string | null | undefined, tags: string[] | null | undefined, centrum: string | null | undefined, subcentra: string | null | undefined, dossier: string | null | undefined, page: number | undefined, pageSize: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/pages/events/count/filter?";
        if (department !== undefined && department !== null)
            url_ += "Department=" + encodeURIComponent("" + department) + "&";
        if (subdepartment !== undefined && subdepartment !== null)
            url_ += "Subdepartment=" + encodeURIComponent("" + subdepartment) + "&";
        if (specialist !== undefined && specialist !== null)
            url_ += "Specialist=" + encodeURIComponent("" + specialist) + "&";
        if (tags !== undefined && tags !== null)
            tags && tags.forEach(item => { url_ += "Tags=" + encodeURIComponent("" + item) + "&"; });
        if (centrum !== undefined && centrum !== null)
            url_ += "Centrum=" + encodeURIComponent("" + centrum) + "&";
        if (subcentra !== undefined && subcentra !== null)
            url_ += "Subcentra=" + encodeURIComponent("" + subcentra) + "&";
        if (dossier !== undefined && dossier !== null)
            url_ += "Dossier=" + encodeURIComponent("" + dossier) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredEventsCount(_response);
        });
    }

    protected processGetFilteredEventsCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getFilteredNewsAndEvents(department: string | null | undefined, subdepartment: string | null | undefined, specialist: string | null | undefined, tags: string[] | null | undefined, centrum: string | null | undefined, subcentra: string | null | undefined, dossier: string | null | undefined, page: number | undefined, pageSize: number | undefined, shouldContainExcludedTags: boolean | undefined): Promise<NewsOrEvent[]> {
        let url_ = this.baseUrl + "/api/v1/pages/newsandevents/filter?";
        if (department !== undefined && department !== null)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        if (subdepartment !== undefined && subdepartment !== null)
            url_ += "subdepartment=" + encodeURIComponent("" + subdepartment) + "&";
        if (specialist !== undefined && specialist !== null)
            url_ += "specialist=" + encodeURIComponent("" + specialist) + "&";
        if (tags !== undefined && tags !== null)
            tags && tags.forEach(item => { url_ += "tags=" + encodeURIComponent("" + item) + "&"; });
        if (centrum !== undefined && centrum !== null)
            url_ += "centrum=" + encodeURIComponent("" + centrum) + "&";
        if (subcentra !== undefined && subcentra !== null)
            url_ += "subcentra=" + encodeURIComponent("" + subcentra) + "&";
        if (dossier !== undefined && dossier !== null)
            url_ += "dossier=" + encodeURIComponent("" + dossier) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (shouldContainExcludedTags === null)
            throw new Error("The parameter 'shouldContainExcludedTags' cannot be null.");
        else if (shouldContainExcludedTags !== undefined)
            url_ += "shouldContainExcludedTags=" + encodeURIComponent("" + shouldContainExcludedTags) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredNewsAndEvents(_response);
        });
    }

    protected processGetFilteredNewsAndEvents(response: Response): Promise<NewsOrEvent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewsOrEvent[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewsOrEvent[]>(null as any);
    }

    getFilteredNewsAndEventsCount(department: string | null | undefined, subdepartment: string | null | undefined, specialist: string | null | undefined, tags: string[] | null | undefined, centrum: string | null | undefined, subcentra: string | null | undefined, shouldContainExcludedTags: boolean | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/pages/newsandevents/count/filter?";
        if (department !== undefined && department !== null)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        if (subdepartment !== undefined && subdepartment !== null)
            url_ += "subdepartment=" + encodeURIComponent("" + subdepartment) + "&";
        if (specialist !== undefined && specialist !== null)
            url_ += "specialist=" + encodeURIComponent("" + specialist) + "&";
        if (tags !== undefined && tags !== null)
            tags && tags.forEach(item => { url_ += "tags=" + encodeURIComponent("" + item) + "&"; });
        if (centrum !== undefined && centrum !== null)
            url_ += "centrum=" + encodeURIComponent("" + centrum) + "&";
        if (subcentra !== undefined && subcentra !== null)
            url_ += "subcentra=" + encodeURIComponent("" + subcentra) + "&";
        if (shouldContainExcludedTags === null)
            throw new Error("The parameter 'shouldContainExcludedTags' cannot be null.");
        else if (shouldContainExcludedTags !== undefined)
            url_ += "shouldContainExcludedTags=" + encodeURIComponent("" + shouldContainExcludedTags) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredNewsAndEventsCount(_response);
        });
    }

    protected processGetFilteredNewsAndEventsCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getWaitingTimesPage(): Promise<SearchableWaitingTimesPage> {
        let url_ = this.baseUrl + "/api/v1/pages/waiting-times";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWaitingTimesPage(_response);
        });
    }

    protected processGetWaitingTimesPage(response: Response): Promise<SearchableWaitingTimesPage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableWaitingTimesPage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableWaitingTimesPage>(null as any);
    }

    getFriendHomePage(): Promise<SearchableFriendPage> {
        let url_ = this.baseUrl + "/api/v1/pages/friend-page";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFriendHomePage(_response);
        });
    }

    protected processGetFriendHomePage(response: Response): Promise<SearchableFriendPage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableFriendPage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableFriendPage>(null as any);
    }

    getFriendOrFriendHomePage(slug: string): Promise<SearchableFriendPage> {
        let url_ = this.baseUrl + "/api/v1/pages/friend-page/{slug}";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFriendOrFriendHomePage(_response);
        });
    }

    protected processGetFriendOrFriendHomePage(response: Response): Promise<SearchableFriendPage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableFriendPage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableFriendPage>(null as any);
    }

    getDepartmentOrCentrumPage(slug: string): Promise<SearchableBasePage> {
        let url_ = this.baseUrl + "/api/v1/pages/department-or-centrum/{slug}";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDepartmentOrCentrumPage(_response);
        });
    }

    protected processGetDepartmentOrCentrumPage(response: Response): Promise<SearchableBasePage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableBasePage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableBasePage>(null as any);
    }

    getDepartmentOrCentrumPages(): Promise<DepartmentOrCentrumPages> {
        let url_ = this.baseUrl + "/api/v1/pages/department-or-centrum";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDepartmentOrCentrumPages(_response);
        });
    }

    protected processGetDepartmentOrCentrumPages(response: Response): Promise<DepartmentOrCentrumPages> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DepartmentOrCentrumPages;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DepartmentOrCentrumPages>(null as any);
    }

    getSubdepartmentOrDepartmentOrSubCentrumOrSpaarnePage(departmentOrCentrumSlug: string | null | undefined, slug: string | null | undefined): Promise<SearchableBasePage> {
        let url_ = this.baseUrl + "/api/v1/pages/subdepartment-or-department-or-subcentra-or-spaarne?";
        if (departmentOrCentrumSlug !== undefined && departmentOrCentrumSlug !== null)
            url_ += "departmentOrCentrumSlug=" + encodeURIComponent("" + departmentOrCentrumSlug) + "&";
        if (slug !== undefined && slug !== null)
            url_ += "slug=" + encodeURIComponent("" + slug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubdepartmentOrDepartmentOrSubCentrumOrSpaarnePage(_response);
        });
    }

    protected processGetSubdepartmentOrDepartmentOrSubCentrumOrSpaarnePage(response: Response): Promise<SearchableBasePage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableBasePage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableBasePage>(null as any);
    }

    getSubdepartmentOrSpaarnePage(centrumSlug: string | null | undefined, departmentOrSpaarneSlug: string | null | undefined, slug: string | null | undefined): Promise<SearchableBasePage> {
        let url_ = this.baseUrl + "/api/v1/pages/subdepartment-or-spaarne?";
        if (centrumSlug !== undefined && centrumSlug !== null)
            url_ += "centrumSlug=" + encodeURIComponent("" + centrumSlug) + "&";
        if (departmentOrSpaarneSlug !== undefined && departmentOrSpaarneSlug !== null)
            url_ += "departmentOrSpaarneSlug=" + encodeURIComponent("" + departmentOrSpaarneSlug) + "&";
        if (slug !== undefined && slug !== null)
            url_ += "slug=" + encodeURIComponent("" + slug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubdepartmentOrSpaarnePage(_response);
        });
    }

    protected processGetSubdepartmentOrSpaarnePage(response: Response): Promise<SearchableBasePage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableBasePage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableBasePage>(null as any);
    }

    getFolderPage(slug: string): Promise<SearchableFolderPage> {
        let url_ = this.baseUrl + "/api/v1/pages/folderPage/{slug}";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFolderPage(_response);
        });
    }

    protected processGetFolderPage(response: Response): Promise<SearchableFolderPage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableFolderPage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableFolderPage>(null as any);
    }

    getFolderContent(sharePointId: string): Promise<SearchablePatientFolder> {
        let url_ = this.baseUrl + "/api/v1/pages/folderContent/{sharePointId}";
        if (sharePointId === undefined || sharePointId === null)
            throw new Error("The parameter 'sharePointId' must be defined.");
        url_ = url_.replace("{sharePointId}", encodeURIComponent("" + sharePointId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFolderContent(_response);
        });
    }

    protected processGetFolderContent(response: Response): Promise<SearchablePatientFolder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchablePatientFolder;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchablePatientFolder>(null as any);
    }

    getDossierChildPage(dossierSlug: string | null | undefined, slug: string | null | undefined): Promise<SearchableSpaarnePage> {
        let url_ = this.baseUrl + "/api/v1/pages/dossier-child?";
        if (dossierSlug !== undefined && dossierSlug !== null)
            url_ += "dossierSlug=" + encodeURIComponent("" + dossierSlug) + "&";
        if (slug !== undefined && slug !== null)
            url_ += "slug=" + encodeURIComponent("" + slug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDossierChildPage(_response);
        });
    }

    protected processGetDossierChildPage(response: Response): Promise<SearchableSpaarnePage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableSpaarnePage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableSpaarnePage>(null as any);
    }

    getDossierPage(slug: string): Promise<SearchableDossierPage> {
        let url_ = this.baseUrl + "/api/v1/pages/dossierPage/{slug}";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDossierPage(_response);
        });
    }

    protected processGetDossierPage(response: Response): Promise<SearchableDossierPage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchableDossierPage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchableDossierPage>(null as any);
    }
}

export interface SearchableListItemBase {
    SharepointId: number;
    Title: string | undefined;
    Created: Date;
    Modified: Date;
    ModerationStatus: number;
    MajorVersion: number;
    MinorVersion: number;
}

export interface SearchableFacilityStructure extends SearchableListItemBase {
    Department: SearchableDepartment | undefined;
    Subdepartment: SearchableSubdepartment | undefined;
    Centrum: SearchableCentrum | undefined;
    Subcentrum: SearchableSubcentra | undefined;
    ClinicType: SearchableClinicType | undefined;
    Location: SearchableLocation | undefined;
    Order: number;
}

export interface SearchableDepartment extends SearchableListItemBase {
    Centrum: SearchableCentrum | undefined;
    PhoneNumber1: SearchablePhoneNumber | undefined;
    Description1: string | undefined;
    PhoneNumber2: SearchablePhoneNumber | undefined;
    Description2: string | undefined;
    PhoneNumber3: SearchablePhoneNumber | undefined;
    Description3: string | undefined;
    AppointmentURL: string | undefined;
}

export interface SearchableCentrum extends SearchableListItemBase {
    PhoneNumber1: SearchablePhoneNumber | undefined;
    Description1: string | undefined;
    PhoneNumber2: SearchablePhoneNumber | undefined;
    Description2: string | undefined;
    PhoneNumber3: SearchablePhoneNumber | undefined;
    Description3: string | undefined;
    AppointmentURL: string | undefined;
}

export interface SearchablePhoneNumber extends SearchableListItemBase {
    PhoneNumber: string | undefined;
    Description: string | undefined;
}

export interface SearchableSubdepartment extends SearchableListItemBase {
    Department: SearchableDepartment | undefined;
    PhoneNumber1: SearchablePhoneNumber | undefined;
    Description1: string | undefined;
    PhoneNumber2: SearchablePhoneNumber | undefined;
    Description2: string | undefined;
    PhoneNumber3: SearchablePhoneNumber | undefined;
    Description3: string | undefined;
    AppointmentURL: string | undefined;
}

export interface SearchableSubcentra extends SearchableListItemBase {
    Centra: SearchableCentrum | undefined;
    PhoneNumber1: SearchablePhoneNumber | undefined;
    Description1: string | undefined;
    PhoneNumber2: SearchablePhoneNumber | undefined;
    Description2: string | undefined;
    PhoneNumber3: SearchablePhoneNumber | undefined;
    Description3: string | undefined;
    AppointmentURL: string | undefined;
}

export interface SearchableClinicType extends SearchableListItemBase {
    VisitTime: string | undefined;
    OpeningTime: string | undefined;
    Route: string | undefined;
    Kind: ClinicKind;
    PhoneNumber: SearchablePhoneNumber[] | undefined;
}

export type ClinicKind = "Verpleegafdeling" | "Polikliniek";

export interface SearchableLocation extends SearchableListItemBase {
    OpeningTimes: string | undefined;
    OpeningTimesPolyclinic: string | undefined;
    VisitingTimes: string | undefined;
    Email: string | undefined;
    Address: string | undefined;
    PostalAddress: string | undefined;
    PhoneNumbers: SearchablePhoneNumber[] | undefined;
}

export interface SearchablePageMeta extends SearchableListItemBase {
    Path: string | undefined;
    MetaTitle: string | undefined;
    MetaDescription: string | undefined;
    AbsolutePath: string | undefined;
    Level: number;
}

export interface SearchableBasePage extends SearchablePageMeta {
    HeaderTitle: string | undefined;
    HeaderDescription: string | undefined;
    HeaderLink: HyperLink | undefined;
    HeaderImage: HyperLink | undefined;
    Content: string | undefined;
    PageText: string | undefined;
    ContentType: string | undefined;
    LinkedPages: number[] | undefined;
    NoIndex: boolean;
}

export interface SearchableSpaarnePage extends SearchableBasePage {
    Language: SearchableLocalisationLanguage | undefined;
    Parent: SearchableParentPage | undefined;
    HideFromNavigation: boolean;
    Rank: number;
    ExcludeFromSearch: boolean;
}

export interface SearchableLocalisationLanguage extends SearchableListItemBase {
    Code: string | undefined;
}

export interface SearchableParentPage extends SearchableBasePage {
    Centrum: SearchableCentrum | undefined;
    Language: SearchableLocalisationLanguage | undefined;
    Parent: SearchableParentPage | undefined;
}

export interface HyperLink {
    Title: string | undefined;
    Url: string | undefined;
}

export interface LinkData {
    Title: string | undefined;
    Url: string | undefined;
}

export interface SearchableHomePage extends SearchableBasePage {
    Language: SearchableLocalisationLanguage | undefined;
}

export interface SearchableLocationPage extends SearchableBasePage {
    Location: SearchableLocation | undefined;
}

export interface SearchableCentrumPage extends SearchableBasePage {
    Centrum: SearchableCentrum | undefined;
    TeaserDescription: string | undefined;
}

export interface SearchableSubcentraPage extends SearchableBasePage {
    Subcentra: SearchableSubcentra | undefined;
    HideFromNavigation: boolean;
    Rank: number;
    HideWaitingTimes: boolean;
}

export interface SearchableDepartmentPage extends SearchableBasePage {
    Department: SearchableDepartment | undefined;
    TeaserDescription: string | undefined;
}

export interface SearchableSubdepartmentPage extends SearchableBasePage {
    Subdepartment: SearchableSubdepartment | undefined;
}

export interface SearchableSpecialistPage extends SearchableBasePage {
    Specialist: SearchableSpecialist | undefined;
}

export interface SearchableSpecialist extends SearchableListItemBase {
    Name: string | undefined;
    Tussenvoegsel: string | undefined;
    Surname: string | undefined;
    AcademicTitle: string | undefined;
    Role: string | undefined;
    Image: HyperLink | undefined;
    Doctor: boolean;
    Study: string | undefined;
    AreasOfFocus: string | undefined;
    BIGRegistrationNumber: string | undefined;
    AuxiliaryFunctions: string | undefined;
    Departments: SearchableDepartment[] | undefined;
    Subdepartments: SearchableSubdepartment[] | undefined;
    Centra: SearchableCentrum[] | undefined;
    Subcentra: SearchableSubcentra[] | undefined;
}

export interface SearchableCrisisBannerPage extends SearchableBasePage {
    Enabled: boolean;
}

export interface SearchableResearchPage extends SearchableBasePage {
    Research: SearchableResearch | undefined;
    TeaserDescription: string | undefined;
    Onderwerp: string | undefined;
}

export interface SearchableResearch extends SearchableListItemBase {
    PatientNeeded: boolean;
    Specialists: SearchableSpecialist[] | undefined;
    Departments: SearchableDepartment[] | undefined;
}

export interface SearchableNewsPage extends SearchableBasePage {
    PublicationDate: Date;
    TeaserDescription: string | undefined;
    Author: SearchableAuthor | undefined;
    DepartmentsTitles: string[] | undefined;
    SubdepartmentsTitles: string[] | undefined;
    SpecialistsTitles: string[] | undefined;
    Tags: SearchableTag[] | undefined;
    CentraTitles: string[] | undefined;
    SubcentraTitles: string[] | undefined;
    Highlighted: boolean;
    Dossier: SearchableDossier | undefined;
}

export interface SearchableAuthor extends SearchableListItemBase {
    Image: HyperLink | undefined;
    Role: string | undefined;
    Link: HyperLink | undefined;
}

export interface SearchableTag extends SearchableListItemBase {
}

export interface SearchableDossier extends SearchableListItemBase {
    DossierPage: SearchableDossierPage | undefined;
}

export interface SearchableDossierPage extends SearchableBasePage {
}

export interface NewsTeaserResult {
    Index: number;
    Title: string | undefined;
    AbsolutePath: string | undefined;
    PublicationDate: Date;
}

export interface DossierNewsResult {
    HighlightedNewsPage: SearchableNewsPage | undefined;
    NewsPages: SearchableNewsPage[] | undefined;
    TotalCount: number;
}

export interface DossierHighlightResult {
    DossierPath: string | undefined;
    NewsPages: SearchableNewsPage[] | undefined;
}

export interface SearchableAgendaEventPage extends SearchableBasePage {
    PublicationDate: Date;
    EventDate: Date;
    DepartmentsTitles: string[] | undefined;
    SubdepartmentsTitles: string[] | undefined;
    SpecialistsTitles: string[] | undefined;
    Tags: SearchableTag[] | undefined;
    CentraTitles: string[] | undefined;
    SubcentraTitles: string[] | undefined;
    TeaserDescription: string | undefined;
    Dossier: SearchableDossier | undefined;
}

export interface NewsOrEvent {
    ContentType: string | undefined;
    EventDate: Date | undefined;
    HeaderImage: HyperLink | undefined;
    HeaderTitle: string | undefined;
    TeaserDescription: string | undefined;
    Title: string | undefined;
    Path: string | undefined;
    AbsolutePath: string | undefined;
    PublicationDate: Date;
}

export interface SearchableWaitingTimesPage extends SearchableBasePage {
}

export interface SearchableFriendPage extends SearchableBasePage {
    ShowSidemenu: boolean;
}

export interface DepartmentOrCentrumPages {
    DepartmentPages: SearchableDepartmentPage[] | undefined;
    CentrumPages: SearchableCentrumPage[] | undefined;
}

export interface SearchableFolderPage extends SearchableBasePage {
    FolderId: number;
    PageTitle: string | undefined;
    PageSubtitle: string | undefined;
    PublicationDate: Date | undefined;
}

export interface SearchableFile extends SearchableListItemBase {
    FileName: string | undefined;
    UniqueId: string | undefined;
    Path: string | undefined;
}

export interface SearchablePatientFolder extends SearchableFile {
    Departments: SearchableDepartment[] | undefined;
    Subdepartments: SearchableSubdepartment[] | undefined;
    Centra: SearchableCentrum[] | undefined;
    Subcentra: SearchableSubcentra[] | undefined;
    FolderTags: SearchableFolderTag[] | undefined;
    DocumentTitle: string | undefined;
    DocumentNumber: string | undefined;
    Introduction: string | undefined;
    HTML: string | undefined;
    Titel: string | undefined;
    Subtitel: string | undefined;
    PublicatieDatum: Date | undefined;
}

export interface SearchableFolderTag extends SearchableListItemBase {
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}